import { render, staticRenderFns } from "./faturabasma.vue?vue&type=template&id=6c6cdd6a&"
import script from "./faturabasma.vue?vue&type=script&lang=js&"
export * from "./faturabasma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports